<template>
	<v-menu
			offset-y
			:close-on-content-click="false"
			min-width="300"
			max-width="300">
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				dark
				x-small
				color="#524D4D"
				v-bind="attrs"
				v-on="on"
			>
				<p class="mb-0 mr-1" style="font-size: 10px">Cambiar</p>
				<v-icon dark x-small>mdi-swap-horizontal-bold</v-icon>
			</v-btn>
		</template>
		<div>
			<v-list dense class="py-0">
				<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
					<p class="caption mb-0 font-weight-bold white--text">Cambiar Empresa</p>
				</v-list-item>
				<v-btn-toggle
					v-model="selectedType"
					dense
					tile
					mandatory
					class="d-flex flex-row custom-toggle-btns"
				>
					<v-btn :value="1" class="flex-grow-1"
						:color="selectedType == 1 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="selectedType == 1 ? 'white--text':''">Mis Empresas</p>
							<p class="mb-0 font-weight-bold" style="font-size: 9px;line-height: 9px" :class="selectedType == 1 ? 'white--text':''">Creadas por ti</p>
						</div>
					</v-btn>
					<v-btn :value="2" class="flex-grow-1"
						:color="selectedType == 2 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="selectedType == 2 ? 'white--text':''">Otras Empresas</p>
							<p class="mb-0 font-weight-bold" style="font-size: 9px;line-height: 9px" :class="selectedType == 2 ? 'white--text':''">Con las que trabajas</p>
						</div>
					</v-btn>
				</v-btn-toggle>
				<v-list-item-group color="#524D4D">
					<v-list-item
						v-for="(company, index) in companies"
						:key="index"
						dense
						@click="changeCompany(company)"
					>
						<v-list-item-title dense>
							<div class="d-flex align-center">
								<img :src="company.company.logo" style="height: 25px; width: 25px; margin-right: 10px;object-fit: contain;" v-if="company.company.logo"/>
								<v-icon v-else style="height: 25px; width: 25px; margin-right: 10px;background-color: #f2f2f2" color="#524D4D" small>mdi-image-off-outline</v-icon>
								<p class="mb-0 font-weight-bold caption">{{ company.company.name }}</p>
							</div>
						</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</div>
	</v-menu>
</template>
<script>
export default {
	name: 'CompanySelectorMenu',
	computed: {
		userInfo(){
			return this.$store.state.user.userInfo
		},
		companies(){
			if(this.selectedType == 1){
				return this.$store.state.companies.companiesList.filter(c => c.company.responsible == this.userInfo.id)
			}
			else if(this.selectedType == 2){
				return this.$store.state.companies.companiesList.filter(c => c.company.responsible != this.userInfo.id)
			}
			return this.$store.state.companies.companiesList
		},
	},
	data(){
		return {
			selectedType: 1,
		}
	},
	methods: {
		async changeCompany(company){
			await localStorage.setItem('company_id', company.company_id)
			window.location.href = '/'
		},
	},
}
</script>